/**
 * 내 기록 — 최고 점수와 내 도감은 **이 브라우저에만** 남긴다(작업지시서 3절 · 서버에 점수 순위가 없다).
 *
 * localStorage 한 칸에 JSON 으로 둔다. 쓸 수 없는 브라우저(사생활 모드 등)에서는 조용히 이번 방문 동안만 기억한다.
 */
import type { Item } from './api';

const STORAGE_KEY = 'pop.alchemist.v1';

interface Saved {
    best: number;
    /** 이름표 → 만든 가장 높은 등급 · 이름 · 그림 */
    items: Record<string, { name: string; emoji: string; grade: number }>;
}

function load(): Saved {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        const parsed = raw ? (JSON.parse(raw) as Partial<Saved>) : {};
        return { best: Number(parsed.best) || 0, items: parsed.items ?? {} };
    } catch {
        return { best: 0, items: {} };
    }
}

class Collection {
    best = $state(0);
    items = $state<Saved['items']>({});

    constructor() {
        const saved = load();
        this.best = saved.best;
        this.items = saved.items;
    }

    get count(): number {
        return Object.keys(this.items).length;
    }

    remember(item: Item): void {
        const known = this.items[item.key];
        if (!known || known.grade < item.grade) {
            this.items = { ...this.items, [item.key]: { name: item.name, emoji: item.emoji, grade: item.grade } };
            this.save();
        }
    }

    finish(score: number): boolean {
        if (score <= this.best) {
            return false;
        }
        this.best = score;
        this.save();
        return true;
    }

    private save(): void {
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify({ best: this.best, items: this.items }));
        } catch {
            // 저장할 수 없는 브라우저 — 이번 방문 동안만 기억한다
        }
    }
}

export const collection = new Collection();
